import FormaPago from './efe_trans.js'
import {useState, useEffect} from 'react'
import Buscar from './buscar_socio.js'

const Cobrar = (props) => {
    const [socios, setSocios] = useState([])
    const [planes, setPlanes] = useState([])
    const [elegidos, setElegidos] = useState([])
    const [checkboxes, setCheckboxes] = useState({});
    const [total,setTotal] = useState (0)
    const [trans, setTrans] = useState(0)
    const [efe, setEfe] = useState(0)
    const meses = ['Septiembre','Octubre','Noviembre','Diciembre','Enero']
    const [habilitado, setHabilitado] = useState(false)
    const [recargar, setRecargar] = useState(0)
    
    const isCheckboxDisabled = (id) => {
        return (elegidos[0].pileta[0].pagadas > id)
    };
   
   const handleCheckboxChange = (id) => {
        if (isCheckboxDisabled(id)) return; 
        
        setCheckboxes(prev => {
            const nuevoEstado = { ...prev };
            
            if (!nuevoEstado[id]) {
                for (let i = 0; i <= id; i++) {
                    if (!isCheckboxDisabled(i)) { 
                        nuevoEstado[i] = true;
                    }
                }
            } else {
                for (let i = id; i <= elegidos[0].pileta[0].cantcuota; i++) {
                    if (!isCheckboxDisabled(i)) { 
                        nuevoEstado[i] = false;
                    }
                }
            }
            
            return nuevoEstado;
        });
    };

    useEffect(() => {
        if(!elegidos.length) return
        if (!elegidos[0].pileta[0].contado) {
            const indicesSeleccionados = Object.entries(checkboxes).filter(([index, checked]) => checked).map(([index]) => parseInt(index))
            const total = indicesSeleccionados.reduce((acumulador, indiceActual) => {
                 return acumulador + valor_cuota(indiceActual);
            }, 0)
            setTotal(total);
        } else {
            setTotal(elegidos[0].pileta[0].valorcontado)
        }
    }, [checkboxes, elegidos]);
   
    useEffect(() => {
        setCheckboxes({})
    },[elegidos])

    const guardar = () => {
        setHabilitado(true)
        const a = {
            cuantas: Object.values(checkboxes).filter(value => value === true).length,
            cuales: elegidos.map(a => a.id)
        }
        fetch(props.back + 'admin/pagar_cuotas_pileta', {
            method: 'POST',
            body: JSON.stringify(a),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => {
            const nuevo = elegidos.map(e => {
                return {...e, pileta: e.pileta.map(z => {return  {...z, pagadas: z.pagadas += a.cuantas}})}
            })
            setElegidos(nuevo)
            const b = {socioId: elegidos[0].id, transferencia: trans, efectivo: efe}
            fetch(props.back + 'admin/guardar_recibo_pileta', {
                method: 'POST',
                body: JSON.stringify(b),
                headers: {
                    'Authorization': 'Bearer ' + props.token,
                    'Content-Type': 'application/json' 
                }
            })
            .then (response => response.json())
            .then (json => {
                
                setElegidos([])
                setHabilitado(false)
                setEfe(0)
                setTrans(0)
            })
        })
    }


    useEffect (() => {
        fetch(props.back + 'admin/traer_socios_pileta', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
            })
            .then (response => response.json())
            .then (json => {setSocios(json)})
        fetch(props.back + 'admin/traer_importes_pileta', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
            })
            .then (response => response.json())
            .then (json => {setPlanes(json)})
    },[props.back, props.token,recargar])

    const nombre_plan = () => {
        return planes.find(z => z.id === elegidos[0].pileta[0].planId).grupo  
    }

    const fecha_plan = () => {
        const base = elegidos[0].pileta[0].fecha.split('T')[0]
        return base.substring(8) + '-' + base.substring(5,7) + '-' + base.substring(0,4)
    }

    const formaPago = () => {
        if (elegidos[0].contado)
            return 'Contado  $ ' + elegidos[0].pileta[0].valorcontado
        else
            return elegidos[0].pileta[0].cantcuota + ' cuotas de $ ' + elegidos[0].pileta[0].valorcuota
    }

    const valor_cuota = (i) => {
        const fecha = new Date()
        const mes = fecha.getMonth() + 1
        return  mes <= (5-elegidos[0].pileta[0].cantcuota) + 8+i || (fecha.getDate() < 16 && mes===(5-elegidos[0].pileta[0].cantcuota) + 9+i) ? elegidos[0].pileta[0].valorcuota : elegidos[0].pileta[0].valorrecargo
    }

    const anular = () => {
        const ids=elegidos.map(a => {return a.pileta[0].id})
        fetch(props.back + 'admin/eliminar_plan_pileta', {
            method: 'POST',
            body: JSON.stringify({ids: ids}),
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
        })
        .then (response => response.json())
        .then (json => {
            setElegidos([])
            setRecargar(recargar+1)
        })
    }


   return (<>
        <div className='flex flex-row px-2'>
            <div className='flex flex-col w-1/2 items-center mt-2'>
            {elegidos.length ?
                <div className='flex flex-col w-2/3'>
                    <div className='flex flex-row justify-between items-center'>
                        <label>Plan</label>
                        <label>{nombre_plan()}</label>
                    </div>
                    <div className='flex flex-row justify-between items-center'>
                        <label>Fecha plan</label>
                        <label>{fecha_plan()}</label>
                    </div>
                    {!elegidos[0].pileta[0].contado ? (<>
                        <div className='flex flex-row justify-between items-center'>
                            <label>Forma de pago</label>
                            <label>{formaPago()}</label>
                        </div>
                    </>)
                    :
                    (<>
                       <div className='flex flex-row justify-between items-center'>
                            <label>Forma de pago</label>
                        <label>Contado</label>
                        </div>
                    </>)
                    }
                    <div className='flex flex-row justify-between items-center mt-2'>
                        <label>Integarntes Grupo</label>
                        <div className='flex flex-col'>
                        {elegidos.map(a => {
                            return <label className=' w-full text-base'>{a.apellido + ' ' + a.nombre}</label>
                        })}
                        </div>
                    </div>
                    {!elegidos[0].pileta[0].contado ?
                    <div className='flex flex-col justify-center items-center mt-2 w-full'>
                        {Array.from({ length: elegidos[0]?.pileta[0]?.cantcuota || 0 }, (_, index) => {
                            return (
                                <div className='grid grid-cols-2 w-full'>
                                    <div className='flex flex-row'>
                                    <input
                                        type="checkbox"
                                        checked={checkboxes[index] || false}
                                        onChange={() => handleCheckboxChange(index)}
                                        className='w-3 mr-5 text-base'
                                        disabled={elegidos[0].pileta[0].pagadas > index}
                                    /> 
                                    <label>{'Cuota ' + meses[parseInt(index + 5 -  elegidos[0]?.pileta[0]?.cantcuota)]} </label>
                                    </div>
                                    <label className='flex justify-end'>{elegidos[0].pileta[0].pagadas > index ? 'Pagada' : valor_cuota(index)}</label>
                                </div>
                            )
                        })}
                        <div className='grid grid-cols-2 w-full mt-2'>
                            <label>Total a cobrar</label>
                            <label className='flex justify-end'>{total}</label>
                        </div>
                    </div>
                    :
                        <div className='grid grid-cols-2 w-full mt-5'>
                            <label>Total a cobrar</label>
                            <label className='flex justify-end'>{elegidos[0].pileta[0].valorcontado}</label>
                        </div>
                    }
                    {total || elegidos[0].pileta[0].contado ?
                        <div className='flex justify-center items-center w-full mt-5'>
                        <FormaPago className='w-3/5 mr-5' total={total} efe={efe} setEfe={setEfe} trans={trans} setTrans={setTrans} />
                        <button 
                            className='text-zinc-800 bg-green-400 hover:text-white hover:bg-green-700 text-lg p-2 rounded-xl w-1/5 ml-5 '
                            onClick={() => guardar()}
                            disabled={habilitado}
                        >
                            Cobrar
                        </button>
                        {!elegidos[0].pileta[0].pagadas ?
                         <button 
                            className='text-zinc-800 bg-red-400 hover:text-white hover:bg-red-700 text-lg p-2 rounded-xl w-1/5 ml-5 '
                            onClick={() => anular()}
                        >
                            Anular Plan
                        </button>
                        : '' }
                        </div>
                        :''}
                    </div>
                    : ''}
            </div>
            <div className='flex flex-col w-1/2'>
                <Buscar socios={socios} elegidos={elegidos} setElegidos={setElegidos} cobrar={true} />
            </div> 
        </div>
    </>)
}

export default Cobrar